import {Component, OnInit} from '@angular/core';
import {Location} from '@angular/common';
import {Router} from '@angular/router';

@Component({
    selector: 'app-navigation',
    templateUrl: './navigation.component.html',
    styleUrls: ['./navigation.component.scss']
})
export class NavigationComponent implements OnInit {
    public isCollapsed = true;
    public isHome: boolean;

    constructor(router: Router, location: Location) {
        router.events.subscribe(() => {
            this.checkLocation(location);
        });
    }

    ngOnInit() {
    }

    checkLocation(location) {
        if (location.path() === '/imprint') {
            this.isHome = false;
            return 1;
        } else if (location.path() === '/disclaimer') {
            this.isHome = false;
            return 2;
        } else if (location.path() === '/requirements') {
            this.isHome = false;
            return 4;
        } else {
            this.isHome = true;
            return 3;
        }
    }
}



// WEBPACK FOOTER //
// /media/webdesign/5E0ECC7B0ECC4E29/www/leasytool/src/app/navigation/navigation.component.ts